import React, { useContext } from 'react';
import { Input } from 'reactstrap';
import GoBackButton from '../../../../../components/Buttons/GoBackButton';
import NextButton from '../../../../../components/Buttons/NextButton';
import SignPad from './SignPad';
import { InputLabel } from './UserDetailsForm';
import { DialogContext } from '../../../../../store/context/DialogContext';

const Agreements = ({ hideButtons, step, asLabel, data, handleUpdate, setHasError, setErrorMessage, loading, handleChange, setStep }) => {

    const { showError, showMessage } = useContext(DialogContext);


    const handleNextClick = () => {
        if (!data?.customerSign?.length) {
            setHasError(true);
            showError("Signature Missing.")
            // setErrorMessage("You are required to read all documents and accept them in order to submit the application.");
            return;
        }
        setHasError(false);
        handleUpdate({ nextStep: step + 1, payload: data });
    };

    return (
        <div>
            <div className=''>
                <div>
                    <InputLabel label="Signature" required />
                    <div className='mb-2'></div>
                    <SignPad
                        asLabel={asLabel || loading}
                        value={data?.customerSign}
                        onChange={(sign) => handleChange('customerSign', sign)}
                    />
                </div>
                {/* <div className='d-flex mt-4 '>
                    <Input
                        type="checkbox"
                        checked={data?.tnc}
                        onChange={(e) => {
                            if (!asLabel) {
                                handleChange('tnc', e.target.checked);
                            }
                        }}
                    />
                    <span className='ps-3'>
                        I agree to the <a href="/individual-plus/disclosure" target="_blank" rel="noopener noreferrer">terms and conditions</a>, and confirm that the information provided is accurate and complete to the best of my knowledge.
                    </span>
                </div> */}

            </div>

            {!hideButtons && (
                <div className='d-flex w-100 justify-content-between mt-3'>
                    <GoBackButton
                        loading={loading}
                        onClick={() => setStep(2)}
                    />
                    <NextButton
                        loading={loading}
                        onClick={handleNextClick}
                        // isDisabled={!data?.tnc}
                        isDisabled={!data?.customerSign?.length}
                    />
                </div>
            )}
        </div>
    );
}

export default Agreements